// Dominant planetary glyph — thick ring, drawn in the metal of the reference.
export const Glyph = ({ glyph, color, size = 240, faint = false }) => {
  const ring = Math.max(2, Math.round(size * 0.014));
  return (
    <div
      className="relative flex items-center justify-center rounded-full"
      style={{
        width: size,
        height: size,
        border: `${ring}px solid ${color}`,
        boxShadow: faint ? "none" : `0 0 60px -20px ${color}`,
        opacity: faint ? 0.35 : 1,
      }}
      aria-hidden="true"
    >
      <span
        style={{
          color,
          fontSize: size * 0.5,
          lineHeight: 1,
          fontFamily: '"Cormorant Garamond", serif',
        }}
      >
        {glyph}
      </span>
    </div>
  );
};
